module.exports = __webpack_public_path__ + "img/mainboard_cover_a.086fc02e.png";